export const CLIENTSIDE_HOOK_FLOATING_DROPDOWN_ENABLED = 'floating'
